// Define a global jQuery instance as a singleton to enable jQuery plugins

if (window.$ === undefined) {
  window.$ = require('jquery'); // eslint-disable-line global-require
  window.jQuery = window.$;
}

module.exports = window.$;
